import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 根据第三方平台或通道代码获取基础数据
export function queryThirdPartyMappingList(params) {
  return request({
    url: URL.mdm.basicData.queryThirdPartyMappingList,
    method: 'get',
    params
  })
}

// 根据第三方平台或通道代码和数据类型获取基础数据
export function queryListByChannelDataType(data) {
  return request({
    url: URL.mdm.basicData.queryListByChannelDataType,
    method: 'Post',
    data
  })
}

// 根据第三方平台或通道代码和数据类型获取基础数据
export function queryMapByChannelDataTypeList(data) {
  return request({
    url: URL.mdm.basicData.queryMapByChannelDataTypeList,
    method: 'Post',
    data
  })
}
